import { render, staticRenderFns } from "./Rightdrawer.vue?vue&type=template&id=054afff6&"
import script from "./Rightdrawer.vue?vue&type=script&lang=js&"
export * from "./Rightdrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports